import { useNavigate } from "react-router-dom";

import { EmitSuccessAlert } from "../../../utils/EmitSuccessAlert";
import { EmitError } from "../../../utils/EmitError";
import NoticeService from "../../../services/http/services/NoticeService";
import { INotice } from "../../../interfaces";

export default function useNewNotice() {
    const navigate = useNavigate();

    async function handleSubmit(notice: INotice) {
        try {
            await NoticeService.createNotice(notice);

            EmitSuccessAlert('Aviso cadastrado com sucesso!');

            navigate(`/avisos`);
        } catch (err) {
            EmitError(err, true, 'newNotice_ijapsdjasdp');
        }
    }

    return {
        handleSubmit,
    }
}